import { Injectable } from '@angular/core'
import { HttpCopilotService } from '../copilot/http-copilot.service'
import {
  TransactionActionRequest,
  TransactionsActionResponse,
} from '../../models/commands.model'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CopilotCommandsService {
  constructor(private readonly httpCopilotService: HttpCopilotService) {}

  createCommands(
    transactionsAction: TransactionActionRequest,
  ): Observable<TransactionsActionResponse> {
    return this.httpCopilotService.createCommands(transactionsAction)
  }
}
